<template>
  <div class="game-box">
    <div class="match-address-box">
      <a-radio-group v-if="programId === 5" :value="type" @change="clickType" style="margin-bottom:20px;">
        <a-radio-button :style="{background: type === 1 ? '#aa1f23' : '',border: '1px solid #eee',color: type === 1 ? 'white' : 'black'}" :value="1">
          队伍积分
        </a-radio-button>
        <a-radio-button :style="{background: type === 2 ? '#aa1f23' : '',border: '1px solid #eee',color: type === 2 ? 'white' : 'black'}" icon="download" :value="2">
          运动员数据
        </a-radio-button>
      </a-radio-group>
      <a-button v-if="programId === 5" type="primary" style="background: #aa1f23;border: none;" icon="download" @click="downloadData">
        下载运动员数据
      </a-button>
      <a-table v-if="type === 1" :pagination="false" :rowKey='record=>record.teamId' :columns="columns" :data-source="data">
        <span slot="teamName" slot-scope="text, record">
          <img style="width:50px;height:50px;border-radius:5px;" :src="record.teamLogo"/>&ensp;&ensp;{{ text }}
        </span>
      </a-table>
      <div v-else>
        <div style="width:1200px;text-align: center;height: 50px;line-height: 50px;background: #eee;margin-bottom: 20px;font-size: 14px;">
          <div style="width:50px;float:left;">头像</div>
          <div style="width:80px;float:left;">名字</div>
          <div style="width:80px;float:left;">球衣号</div>
          <div style="width:80px;float:left;">位置</div>
          <div style="width:80px;float:left;">普通犯规</div>
          <div style="width:80px;float:left;">技术犯规</div>
          <div style="width:120px;float:left;">违反体育竞赛</div>
          <div style="width:80px;float:left;">失格犯规</div>
          <div style="width:60px;float:left;">罚球</div>
          <div style="width:80px;float:left;">一分球</div>
          <div style="width:80px;float:left;">两分球</div>
          <div style="width:80px;float:left;">三分球</div>
          <div style="width:120px;float:left;">上场时间（秒）</div>
          <div style="width:120px;float:left;">是否是主场</div>
        </div>
        <div v-for="(item,index) in playerData" :key="index" style="width:1200px;">
          <div v-for="(it,ind) in item" :key="ind" style="width:1200px;height:50px;margin-bottom:20px;overflow: hidden;line-height: 50px;text-align: center;">
            <div v-if="ind === 0" style="width:200px;float:left;">
              <div style="width:50px;float:left;"><img :src="it.head" style="width:50px;height:50px;border-radius:5px;"/></div>
              <div style="width:80px;float:left;">{{ index }}</div>
              <div style="width:70px;float:left;">{{ it.jerseyNumber }}</div>
            </div>
            <div v-else style="width:200px;float:left;height: 50px;">
            </div>
            <div style="width:80px;float:left;">{{ it.location }}</div>
            <div style="width:80px;float:left;">{{ it.commonFoulCount }}</div>
            <div style="width:80px;float:left;">{{ it.technicalFoulcount }}</div>
            <div style="width:120px;float:left;">{{ it.unsportsmanlikeFoulCount }}</div>
            <div style="width:80px;float:left;">{{ it.disqualifyingFoulCount }}</div>
            <div style="width:60px;float:left;">{{ it.freeThrowGoalCount }}</div>
            <div style="width:80px;float:left;">{{ it.onePointShotGoalCount }}</div>
            <div style="width:80px;float:left;">{{ it.twoPointShotGoalCount }}</div>
            <div style="width:80px;float:left;">{{ it.threePointShotGoalCount }}</div>
            <div style="width:120px;float:left;">{{ it.times }}</div>
            <div style="width:120px;float:left;">{{ it.type === 'HOME' ? '主场':'客场' }}</div>
          </div>
        </div>
        <a-empty v-if="Object.keys(playerData).length === 0" style="margin: 40px 0;"/>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@comm/http/config'
export default {
  name: 'BigGameScore',
  components: {
  },
  created () {
    this.findData()
    this.playerGoal()
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      type: 1,
      columns: [{
        title: '队伍信息',
        width: '10%',
        dataIndex: 'teamName',
        scopedSlots: { customRender: 'teamName' }
      },
      {
        title: '胜场',
        width: '10%',
        dataIndex: 'win'
      },
      {
        title: '负场',
        align: 'center',
        width: '10%',
        dataIndex: 'fail'
      },
      {
        title: '平场',
        align: 'center',
        width: '10%',
        dataIndex: 'draw'
      },
      {
        title: '积分',
        align: 'center',
        width: '10%',
        dataIndex: 'score'
      }],
      data: [],
      playerData: {}
    }
  },
  methods: {
    findData () {
      this.$api.battle.footballIntegralRank({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    playerGoal () {
      this.$api.battle.playerGoal({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.playerData = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    clickType (type) {
      this.type = type.target.value
    },
    downloadData () {
      window.location.href = config.baseURL + '/match/download/playerGoalExcel/' + this.matchId
    }
  }
}
</script>
<style lang="scss" scoped>
.match-show-box {
  width: 1200px;
  margin: 0 auto;
  height: 30px;
}
.show-curr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #434343;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.show-nocurr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #ccc;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.font-address-curr {
  font-weight: bold;
  font-size: 20px;
  background: #b80000;
  color: #fff;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.address-right {
  float: left;
  margin-right: 22px;
  cursor: pointer;
  margin-bottom: 20px;
}
.font-address {
  font-weight: bold;
  font-size: 20px;
  background: #eeeeee;
  color: #999999;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.match-address-box {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 20px;
  cursor: pointer;
}
.day-box {
  width: 100px;
  height: 100px;
  float: left;
  cursor: pointer;
}
.match-time-box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  margin-top: 20px;
  position: relative;
  background-image: url(../../assets/dayline.png);
  background-size: 94% 2%;
  background-repeat: no-repeat;
  background-position-y: 39px;
  background-position-x: 36px;
}
.line-left {
  cursor: pointer;
  position: absolute;
  top: 24px;
  left: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  text-align: center;
  line-height: 21px;
  border: 1px solid #a0a0a0;
}
.line-right {
  position: absolute;
  top: 24px;
  right: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 21px;
  border-radius: 100%;
  cursor: pointer;
  border: 1px solid #a0a0a0;
}
.day-font {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-align: center;
}
.day-font-curr {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #b41000;
  text-align: center;
}
.day-curr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #b41000;
  margin-left: 37px;
  background: white;
}
.day-nocurr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #ccc;
  margin-left: 37px;
  background: white;
}
.chang-font {
  width: 60%;
  height: 25px;
  background: #b41000;
  color: white;
  border-radius: 5px;
  margin-left: 20px;
  margin-top: 7px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/BigGameScore.vue